import actionCreatorFactory from "typescript-fsa"

const actionCreator = actionCreatorFactory()
// ReduxのCameraOffState更新アクション
export const cameraOffActions = {
  updateCameraOff: actionCreator<boolean>("ACTIONS_UPDATE_CAMERA_OFF")
}

export default cameraOffActions
